<template>
  <div>
    <div :class="titleStyle">
      Недавно открытые
    </div>
    
    <loader-dots
      v-if="recentDocs === null"
      wrapperCssClass="frontpage__loader"
    />
    
    <template v-if="recentDocs!==null && recentDocs.length">
      <document-snippet-small
        v-for="(item, index) in recentDocs"
        :key="index"
        :document="item.document"
        :format="item.openingFormat"
      />
    </template>
    
    <p v-if="recentDocs!==null && !recentDocs.length">
      Нет документов.
    </p>
  </div>
</template>

<script>
import DocumentSnippetSmall from '@@/shared/snippets/Snippet_Small';
import LoaderDots from '@@/shared/loaders/LoaderDots';

export default {
  props:{
    recentDocs:{
      required: true
    },
    titleStyle: {
      type: String,
      default: () => ''
    }  
  },

  components:{
    LoaderDots,
    DocumentSnippetSmall
  }
};
</script>
